import Vue from 'vue'
import Vuex from 'vuex'
import App from '@/store/modules/app';
import Lantern from '@/store/modules/lantern';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    App,
    Lantern,
  }
})